//slide
var slideProudect = new Swiper('.proudect', {
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {  
      '575.98': {
        slidesPerView: 1,
      },
      '767.98': {
        slidesPerView: 2,
      },
      '991.98': {
        slidesPerView: 3,
      },
      '1199.98': {
        slidesPerView: 5,
      },
    },
});
var slideCategory = new Swiper('.slideCategory', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {  
      '575.98': {
        slidesPerView: 1,
      },
      '767.98': {
        slidesPerView: 2,
      },
      '991.98': {
        slidesPerView: 3,
      },
      '1199.98': {
        slidesPerView: 5,
      },
    },
});
var slideBanar = new Swiper('.slideBanar', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
});

//app
function showInstallPromotion() {
  const installBanner = document.getElementById('installBanner');
  installBanner.style.display = 'flex';
}
const installButton = document.getElementById('installButton');
installButton.addEventListener('click', () => {
  // Hide the app provided install promotion
  const installBanner = document.getElementById('installBanner');
  installBanner.style.display = 'none';
  // Show the install prompt
  deferredPrompt.prompt();
  // Wait for the user to respond to the prompt
  deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    // Clear the deferredPrompt variable
    deferredPrompt = null;
  });
});

// lang
$('.cbCountdownContainerText:lang(ar)').text("اسرع ! قبل ان ينتهي العرض");
$('.soldtext:lang(ar)').text("مُباع 🔥");
$('.invintoytext:lang(ar)').text("المتبقي");
//plus
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

//installed
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = e;
  // Update UI notify the user they can install the PWA
  showInstallPromotion();
});
window.addEventListener('appinstalled', (evt) => {
  console.log('PWA was installed');
});
